@if (loading) {
  <div class="loading-screen-wrapper">
    <div class="loading-screen-icon" style="text-align: center">
      <img src="assets/loading.gif" alt="">
      <!--    <H1>Loading...</H1>-->
    </div>
  </div>
}
